// src/pages/AppliAdmin/ContactForm/components/ContactMessagesPanel.jsx
import React from "react";
import { FaInbox } from "react-icons/fa";
import ContactMessageCard from "./ContactMessageCard";
import ContactMessageTable from "./ContactMessageTable";

export default function ContactMessagesPanel({
  rows,
  loading,
  deletingId,
  markingId,
  onDelete,
  onToggleRead,
  searchTerm,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="border-b border-slate-200 p-4 dark:border-slate-800 sm:p-5">
        <h2 className="text-xl font-bold text-slate-900 dark:text-white">
          Liste des messages
        </h2>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          {rows.length} message{rows.length > 1 ? "s" : ""} affiché
          {rows.length > 1 ? "s" : ""}.
        </p>
      </div>

      {loading ? (
        <LoadingState />
      ) : rows.length === 0 ? (
        <EmptyState searchTerm={searchTerm} />
      ) : (
        <>
          <ContactMessageTable
            rows={rows}
            deletingId={deletingId}
            markingId={markingId}
            onDelete={onDelete}
            onToggleRead={onToggleRead}
          />

          <div className="grid grid-cols-1 gap-3 p-3 lg:hidden">
            {rows.map((message) => (
              <ContactMessageCard
                key={message.id}
                message={message}
                deletingId={deletingId}
                markingId={markingId}
                onDelete={onDelete}
                onToggleRead={onToggleRead}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
}

function LoadingState() {
  return (
    <div className="space-y-3 p-4 sm:p-5">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="flex animate-pulse items-center gap-3 rounded-[24px] border border-slate-100 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/50"
        >
          <div className="h-11 w-11 rounded-2xl bg-slate-200 dark:bg-slate-800" />
          <div className="flex-1 space-y-2">
            <div className="h-3 w-3/4 rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-3 w-1/2 rounded-full bg-slate-200 dark:bg-slate-800" />
          </div>
          <div className="hidden h-9 w-28 rounded-2xl bg-slate-200 dark:bg-slate-800 sm:block" />
        </div>
      ))}
    </div>
  );
}

function EmptyState({ searchTerm }) {
  return (
    <div className="flex flex-col items-center justify-center px-5 py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-[24px] bg-slate-100 text-2xl text-slate-500 dark:bg-slate-800 dark:text-slate-300">
        <FaInbox />
      </div>

      <h3 className="text-lg font-bold text-slate-900 dark:text-white">
        {searchTerm ? "Aucun résultat trouvé" : "Aucun message"}
      </h3>

      <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-500 dark:text-slate-400">
        {searchTerm
          ? "Essayez avec un autre mot-clé ou réinitialisez les filtres."
          : "Les messages envoyés depuis le formulaire de contact apparaîtront ici."}
      </p>
    </div>
  );
}